'use client';

import React from 'react';
import { motion, useInView } from 'framer-motion';

type FadeInProps = {
  children?: React.ReactNode;
  className?: string;
  animation?: {
    duration?: number;
    delay?: number;
    startOpacity?: number;
    startBackgroundColor?: string;
    endOpacity?: number;
    endBackgroundColor?: string;
  };
  onAnimationComplete?: () => void;
  onAnimationStart?: () => void;
};

function FadeIn({
  children,
  className,
  animation,
  onAnimationComplete,
  onAnimationStart
}: FadeInProps) {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true });
  const variants = {
    hidden: {
      opacity: animation?.startOpacity || 0,
      transition: {
        duration: animation?.duration || 0.5,
        delay: animation?.delay || 0,
        ease: [.25, .1, .25, 1] as [number, number, number, number]
      }
    },

    visible: {
      opacity: animation?.endOpacity || 1,
      transition: {
        duration: animation?.duration || 0.5,
        delay: animation?.delay || 0,
        ease: [.25, .1, .25, 1] as [number, number, number, number]
      }
    }
  };

  return (
    <motion.div
      ref={ref}
      variants={variants}
      initial="hidden"
      animate={isInView ? 'visible' : 'hidden'}
      className={`relative ${className || ''} `}
      onAnimationStart={onAnimationStart}
      onAnimationComplete={onAnimationComplete}
    >
      {children}
    </motion.div>
  );
}

export default FadeIn;